// extracted by mini-css-extract-plugin
export var img = "HeroWithBg-module--img--TwKKx";
export var inner = "HeroWithBg-module--inner--2aHsC";
export var root = "HeroWithBg-module--root--QlXlX";
export var txt = "HeroWithBg-module--txt--hrwPn";